import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import Iconify from '../iconify';

ExcelDownloadTemplateButton.propTypes = {
  id: PropTypes.number,
}

export default function ExcelDownloadTemplateButton({ id }) {
  return <Button
    variant="outlined"
    color="secondary"
    size="small"
    onClick={() => {
      window.open(`/Api/ExcelUpload/ExcelUploadTemplate?typeId=${id}`, '_blank');
    }}
    startIcon={<Iconify icon="file-icons:microsoft-excel" />}
    sx={{ ml: 2 }}
  >
    Download Template
  </Button>;
}
